import * as styles from 'styles/pages/Styleguide.css'
import TextField from 'components/atoms/inputs/TextField'
import { ErrorItemState } from 'interfaces/component'
import { Caption } from 'components/atoms/Text'
import OldRadioButton from 'components/atoms/inputs/OldRadioButton'
import Checkbox from 'components/atoms/inputs/Checkbox'

const fieldErrors = [
  { text: 'Something went wrong', state: 'errored' as ErrorItemState },
]

const onChange = () => null as any

const SGInputs = () => (
  <section className={ styles.sgSection }>
    <form className={ styles.sgForm }>
      <ul>
        <li>
          <TextField
            label='Full Name'
            type='text'
            value=''
            placeholder='First Last'
            active={ false }
            errored
            errors={ fieldErrors }
            qaMarker='text-field'
          />
          <Caption text='input field' />
        </li>
        <li>
          <TextField
            label='Full Name'
            type='text'
            value='Input'
            placeholder='First Last'
            active
            errored
            errors={ fieldErrors }
            qaMarker='text-field'
          />
          <Caption text='active input field' />
        </li>
        <li style={{ fontSize: '12px' }}>
          <TextField
            label='Full Name'
            type='text'
            value='John Doe'
            placeholder='First Last'
            active
            errored
            errors={ fieldErrors }
            qaMarker='text-field'
          />
          <Caption text='small active input field' />
        </li>
        <li>
          <OldRadioButton
            label='Yes'
            name='radio-buttons'
            value='1'
            checked
            qaMarker='radio1'
            onChange={ onChange }
          />
          <OldRadioButton
            label='No'
            name='radio-buttons'
            value='0'
            checked={ false }
            qaMarker='radio2'
            onChange={ onChange }
          />
          <Caption text='radio buttons' />
        </li>
        <li>
          <Checkbox
            label='Option 1'
            name='checkboxes'
            checked
            qaMarker='checkbox1'
            onChange={ onChange }
          />
          <Checkbox
            label='Option 2'
            name='checkboxes'
            checked={ false }
            qaMarker='checkbox2'
            onChange={ onChange }
          />
          <Caption text='checkboxes' />
        </li>
        <li>
          <Caption text='toggle switch' />
        </li>
      </ul>
    </form>
  </section>
)

export default SGInputs
